import { useMemo } from "react";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import useModalContext from "common/providers/modal/useModalContext";
import usePartExchangeQuestionsContext from "features/vehicleDetails/providers/partExchangeQuestions/usePartExchangeQuestionsContext";
import { PartExchange as PartExchangeType } from "services/motorpoint/partExchange";
import validatePlateNumber from "utils/validatePlateNumber";

import { valuePartExchangeModal } from "../../../modals";
import styles from "./PartExchange.module.scss";

const cx = classNames.bind(styles);

const PartExchange = ({ buttonLabel }: { buttonLabel: string }) => {
    const { useSidebar } = useModalContext();
    const { openSidebar } = useSidebar();

    const { partExQuestionsVehicle, partExQuestionsAnswersResponse, resetAllQuestionsData } =
        usePartExchangeQuestionsContext();

    const vrm =
        partExQuestionsVehicle?.VRM ??
        (partExQuestionsAnswersResponse as PartExchangeType)?.VehicleRegistration;
    const make =
        partExQuestionsVehicle?.Make ?? (partExQuestionsAnswersResponse as PartExchangeType)?.Make;
    const range =
        partExQuestionsVehicle?.Range ??
        (partExQuestionsAnswersResponse as PartExchangeType)?.Model;

    const formattedVRM = useMemo(() => validatePlateNumber(vrm || ""), [vrm]);

    if (formattedVRM && make && range && partExQuestionsAnswersResponse) {
        return (
            <div className={cx("partExchange")}>
                <div className={cx("badge")}>
                    <span className={cx("label")}>Part exchange</span>
                    <div className={cx("details")}>
                        <span>
                            {make} {range}
                        </span>
                        <span className={cx("regNumber")}>{formattedVRM.formatedPlate}</span>
                    </div>
                    <Button
                        theme="textLink"
                        onClick={() => resetAllQuestionsData()}
                        ariaLabel="Remove vehicle"
                    >
                        Remove vehicle
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className={cx("partExchange")}>
            <Button
                ariaLabel={buttonLabel}
                theme="secondary"
                className={cx("button")}
                fullWidth
                onClick={() => {
                    openSidebar(valuePartExchangeModal);
                }}
            >
                {buttonLabel}
            </Button>
        </div>
    );
};

export default PartExchange;
